<template>
  <button class="tsbutton" @click.prevent="$emit('click')">{{ title }}</button>
</template>

<script>
export default {
  name: "TSButton",
  props: {
    'title': String,
  }
}
</script>

<style lang="scss" scoped>
@import "src/theme.scss";

.tsbutton {
  height: 46px;
  padding: 10px 16px;
  margin-top: 16px;
  outline: none;
  border: 1px solid $black-color;
  background-color: $white-color;
  color: $black-color;
  border-radius: 0;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.429;
}
.tsbutton:hover {
  background-color: rgba(red($black-color), green($black-color), blue($black-color), 0.9);
  color: $white-color;
}
.tsbutton:active {
  background-color: rgba(red($black-color), green($black-color), blue($black-color), 1);
}
</style>